import * as React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Alert from '@material-ui/lab/Alert'
import { Form, FormitConsumer } from '@oakwood/formit'
import Link from 'components/Link'
import LoadingButton from 'components/LoadingButton'
import Typography from 'components/Typography'
import { useTranslations } from 'containers/Translations/TranslationsContext'
import { useAuth } from '../AuthContext'
import AuthCommonFields from './AuthCommonFields'

export const useStyles = makeStyles((theme) => ({
  header: {},
  main: {},
  footer: {},
  submitButton: theme.mixins.inputMargin('normal'),
}))

function AuthRegisterEmail(props) {
  const classes = useStyles(props)
  const { onLoginOrRegisterScreenToggle, formitError } = useAuth()
  const t = useTranslations()

  return (
    <>
      <div className={classes.header}>
        <Typography component="h1" variant="h5">
          {t('Web.AuthRegisterEmail.SignUp')}
        </Typography>

        <Typography>{t('Web.AuthRegisterEmail.NoAccount')}</Typography>
      </div>

      <Form className={classes.main}>
        <AuthCommonFields />

        <FormitConsumer>
          {({ isSubmitting }) => (
            <LoadingButton
              className={classes.submitButton}
              pending={isSubmitting}
              variant="outlined"
              type="submit"
              fullWidth
            >
              {t('Web.AuthRegisterEmail.SignUp')}
            </LoadingButton>
          )}
        </FormitConsumer>

        {formitError && (
          <Alert className={classes.alert} severity="error">
            {formitError?.data?.errors?.sessions?.map((error, idx) => (
              <div key={idx}>{error}</div>
            ))}
          </Alert>
        )}
      </Form>

      <div className={classes.footer}>
        <Typography>{t('Web.AuthRegisterEmail.AlreadyHaveAccount')}</Typography>

        <Link // eslint-disable-line jsx-a11y/anchor-is-valid
          onClick={onLoginOrRegisterScreenToggle}
          component="button"
          type="button"
          underline="always"
          variant="body1"
        >
          {t('Web.AuthRegisterEmail.SignIn')}
        </Link>
      </div>
    </>
  )
}

export default AuthRegisterEmail
